var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManagePreferencesStatusError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    width: "244px",
    height: "118px",
    viewBox: "0 0 244 118",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "errorTitle"
  }, "Error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "errorTitle"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.8162,16 C237.417449,16 241.958159,20.5666956 241.958159,26.2 C241.958159,31.8333044 237.417449,36.4 231.8162,36.4 L173.86215,36.4 C179.463399,36.4 184.004109,40.9666956 184.004109,46.6 C184.004109,52.2333044 179.463399,56.8 173.86215,56.8 L205.736878,56.8 C211.338127,56.8 215.878836,61.3666956 215.878836,67 C215.878836,72.6333044 211.338127,77.2 205.736878,77.2 L190.996391,77.2 C183.933946,77.2 178.208704,81.7666956 178.208704,87.4 C178.208704,91.1555363 181.106406,94.5555363 186.901811,97.6 C192.503061,97.6 197.04377,102.166696 197.04377,107.8 C197.04377,113.433304 192.503061,118 186.901811,118 L66.6471576,118 C61.0459084,118 56.5051988,113.433304 56.5051988,107.8 C56.5051988,102.166696 61.0459084,97.6 66.6471576,97.6 L10.1419588,97.6 C4.5407096,97.6 0,93.0333044 0,87.4 C0,81.7666956 4.5407096,77.2 10.1419588,77.2 L68.0960088,77.2 C73.697258,77.2 78.2379676,72.6333044 78.2379676,67 C78.2379676,61.3666956 73.697258,56.8 68.0960088,56.8 L31.8747275,56.8 C26.2734784,56.8 21.7327688,52.2333044 21.7327688,46.6 C21.7327688,40.9666956 26.2734784,36.4 31.8747275,36.4 L89.8287776,36.4 C84.2275284,36.4 79.6868188,31.8333044 79.6868188,26.2 C79.6868188,20.5666956 84.2275284,16 89.8287776,16 L231.8162,16 Z M233.790795,56.8 C239.429183,56.8 244,61.3666956 244,67 C244,72.6333044 239.429183,77.2 233.790795,77.2 C228.152407,77.2 223.58159,72.6333044 223.58159,67 C223.58159,61.3666956 228.152407,56.8 233.790795,56.8 Z",
    fill: "#ED2570",
    opacity: 0.100000001,
    transform: "translate(122.000000, 67.000000) scale(-1, 1) translate(-122.000000, -67.000000) "
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6239723,4.18103425 C60.758619,4.20836545 60.7775029,4.22724933 60.7905392,4.25002851 L60.7905392,4.25002851 L117.750154,103.77946 C117.770364,103.814776 117.774347,103.85494 117.764449,103.891328 C117.75455,103.927716 117.73077,103.960327 117.695454,103.980538 C117.67317,103.993291 117.647941,104 117.622265,104 L117.622265,104 L3.70303603,104 C3.66234633,104 3.62550871,103.983507 3.59884352,103.956842 C3.57217833,103.930177 3.55568557,103.893339 3.55568557,103.85265 C3.55568557,103.826974 3.56239445,103.801744 3.57514744,103.77946 L3.57514744,103.77946 L60.534762,4.25002851 C60.5549727,4.21471305 60.5875844,4.19093289 60.6239723,4.18103425 Z",
    stroke: "#FD9BBF",
    strokeWidth: 4,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.469880, 45.975904)",
    fill: "#FD9BBF"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 5.10843373,
    height: 31.9277108,
    rx: 2.55421687
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.55421687,
    cy: 38.313253,
    r: 2.55421687
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagePreferencesStatusError);
export default __webpack_public_path__ + "static/media/manage-preferences-status-error.df557110fed0a85913ca4d4f8bbe7445.svg";
export { ForwardRef as ReactComponent };